import Vue from "vue";
import VueLocalStorage from "vue-localstorage";
import Vuex from "vuex";
import config from "@/config";

Vue.use(VueLocalStorage);
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    config: config,
    user: {},
    system: {},
    navigation: [],
    page: '',
    pageTitle: '',
  },
  getters: {},
  mutations: {
    updateAuthData(state, res) {
      state.user = res.user;
      state.system = res.system;
      state.navigation = res.navigation;
    },
    updatePage(state, page) {
      state.page = page;
    },
    updatePageTitle(state, pageTitle) {
      state.pageTitle = pageTitle;
    },
  },
  actions: {
    authInit({commit, state, dispatch}, _this) {
      const userInfoJson = _this.$localStorage.get("auth");
      if (userInfoJson) {
        commit("updateAuthData", JSON.parse(userInfoJson));
      }
      return new Promise((resolve) => {
        _this.$apiAdmin.adminAccountDetail()
          .then(authData => {
            _this.$localStorage.set("auth", JSON.stringify(authData));
            commit("updateAuthData", authData);
            resolve(authData);
          })
          .catch(() => {
            _this.$localStorage.remove("token");
            _this.$localStorage.remove("auth");
            _this.$router.replace({path: config.loginUrl});
          })
      })
    },
  },
  modules: {}
});
